import React from 'react'
import _ from 'underscore'
import { UserPlus, X } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  Card,
  CardAction,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import TutorProposerPosition from './position'
import store from '../../state/store'

class TutorProposer extends React.Component {

  onClose = () => {
    store.emit('ui:tutor_proposer:close')
  }

  render() {
    return (
      <Card className="my-4">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <UserPlus className="size-4"/>
            Propose Tutor
          </CardTitle>
          <CardAction className="ml-auto self-center">
            <Button variant="ghost" size="icon-sm" aria-label="Close proposer" onClick={this.onClose}>
              <X className="size-4"/>
            </Button>
          </CardAction>
        </CardHeader>
        <CardContent className="divide-y divide-border">
          {_.map(this.props.tutoring_job.tutoring_job_positions, (position) => {
            const tutor_proposal = _.first(
              _.select(this.props.tutor_proposals, function(tutor_proposal) {
                return tutor_proposal.tutoring_job_position.id === position.id
              })
            )

            const tutor_subject = _.first(
              _.select(this.props.tutor_result.tutor_subjects, function(tutor_subject) {
                return tutor_subject.subject_id === position.subject_id
              })
            )

            return (
              <TutorProposerPosition
                key={position.id}
                tutoring_job_position={position}
                tutor_result={this.props.tutor_result}
                tutor_proposal={tutor_proposal}
                tutor_subject={tutor_subject}
              />
            )
          })}
        </CardContent>
      </Card>
    )
  }
}

export default TutorProposer
